import { IEProduct } from "api/interfaces/product-api.type";
import { IPageContent } from "api/interfaces/static-content.type";
import { VEHICLE_FITMENT } from "constant/shared-constants";
import { isEmpty } from "./lodash/isEmpty";
import { isApparelProduct } from "./product/apparel";

export function getDisplaySectionList(product: IEProduct | null, staticContent: IPageContent, state = {},
  showVehicleFitment?: boolean, isCompact?: boolean, isWheelTireCategory?: boolean,
  omitSections: string[] = []) {
  const {
    overviewOpen,
    specificationOpen,
    fittingVehicleOpen,
    oeCrossReferenceOpen,
    // reviewsOpen,
    // questionsAnswerOpen,
    faqOpen,
    productHighlightsOpen,
    installationTipsOpen,
    vehicleFitmentOpen,
    sizeChartOpen,
    careGuideOpen,
    dimensionOpen,
  } = state;

  const {
    extendedDescription, fitment, sku, installationTips, filterableAttributes, productHighlights,
  } = product || {};
  const contentIds = staticContent?.links?.contentIds;
  const { specifications, descriptions, ...otherAttributes } = extendedDescription || {};
  const {
    careGuide, dimensions, handling, productSpecification,
    sizeChart,
  } = staticContent.links || {};

  const isFittingVehicleAvailable = fitment && fitment === VEHICLE_FITMENT.VEHICLE_SPECIFIC;
  const isApparel = isApparelProduct(product);

  const isSpecificationAvailable = !isEmpty(specifications) && !isEmpty(specifications[0]);
  const isOEReferenceAvailable = !isEmpty(specifications) && !isEmpty(specifications[1]);

  const filterFaqContent = contentIds && contentIds.find((eachContent: any) => eachContent?.uiDetails?.uiType === "FAQ");
  const filterFaq = filterFaqContent?.uiDetails?.content?.faqs ? filterFaqContent.uiDetails.content.faqs : [];

  let tabsArray = [];
  if ((productHighlights && productHighlights.length > 0)) {
    tabsArray.push({
      title: "Product Highlights",
      id: "PRODUCTHIGHLIGHTS",
      sectionToOpen: productHighlightsOpen,
      productHighlights,
    });
  }
  if (productSpecification?.length > 0) {
    tabsArray.push({
      title: "Product Highlights", id: "PRODUCTHIGHLIGHTS", sectionToOpen: productHighlightsOpen, productHighlights: productSpecification,
    });
  }
  if (isWheelTireCategory && filterableAttributes && Object.keys(filterableAttributes).length > 0) {
    tabsArray.push({
      title: "Product Highlights", id: "PRODUCTHIGHLIGHTS", sectionToOpen: productHighlightsOpen,
    });
  }
  if (showVehicleFitment) {
    tabsArray.push({
      title: "Vehicle Fitment", id: "VEHICLEFITMENT", sectionToOpen: vehicleFitmentOpen,
    });
  }
  if (!isApparel) {
    tabsArray.push({
      title: "Product Overview", id: "OVERVIEW", lazyRender: false, sectionToOpen: overviewOpen,
    });
  }
  if (installationTips && installationTips.length > 0) {
    tabsArray.push({
      title: "Installation Tips", id: "INSTALLATIONTIPS", sectionToOpen: installationTipsOpen, installationTips,
    });
  }

  if (isApparel && isCompact) {
    if (sizeChart?.length) {
      tabsArray.push({
        title: "Size Chart", id: "SIZECHART", sectionToOpen: sizeChartOpen, descriptions,
      });
    }
    if (careGuide?.length) {
      tabsArray.push({
        title: "Care Guide", id: "CAREGUIDE", sectionToOpen: careGuideOpen, descriptions,
      });
    }
    if (dimensions?.length) {
      tabsArray.push({
        title: "Dimensions", id: "DIMENSIONS", sectionToOpen: dimensionOpen,
      });
    }
    if (handling?.length) {
      tabsArray.push({
        title: "Handling", id: "HANDLING",
      });
    }
  }

  if ((isSpecificationAvailable || Object.keys(otherAttributes).length) && !isApparel) {
    tabsArray.push({
      title: "Specifications", id: "SPECIFICATION", sectionToOpen: specificationOpen, descriptions,
    });
  }

  if (isFittingVehicleAvailable) {
    tabsArray.push({ title: "Fitting Vehicle(s)", id: "FITTINGVEHICLE", sectionToOpen: fittingVehicleOpen });
  }

  // https://partsavatar.ca/gates-serpentine-belt-k080852
  if (isOEReferenceAvailable && !isApparel) {
    tabsArray.push({ title: "OE Cross Reference", id: "OECROSSREFERENCE", sectionToOpen: oeCrossReferenceOpen });
  }

  // tabsArray.push({ title: "Reviews", id: "REVIEWS", sectionToOpen: reviewsOpen });

  if (sku) {
    // tabsArray.push({ title: "Questions & Answers", id: "QUESTIONANSWER", sectionToOpen: questionsAnswerOpen });
  }

  if (filterFaq && filterFaq.length > 0) {
    tabsArray.push({
      title: "Frequently Asked Questions", id: "FAQ", sectionToOpen: faqOpen, filterFaq,
    });
  }

  tabsArray = tabsArray.filter(((_) => !omitSections.includes(_.id)));

  return tabsArray;
}
